import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Container, Table } from "react-bootstrap";
import { BsDownload } from "react-icons/bs";
import { connect } from "react-redux";
import {
  GetHistoricDetails, ExportHistoricDetails
} from '../../../store/actions/reports/historic-details';
import { GetSubsRnNums } from '../../../store/actions/vehicle/vehicle.js';
import { getFormattedDate } from "../../../utils/common-methods";
import MapAdddressByLocation from "../../helpers/hoc/latlong-to-address-map/MapAddressByLocation";
import Loader from "../../helpers/hoc/loader/Loader";
import MultiSelect from "../../helpers/hoc/multi-select/MultiSelect";
import NoRecordFound from "../../helpers/hoc/noRecordFound";
import Pagination from "../../helpers/hoc/paginator/Pagination";
import BreakdownBadge from '../../helpers/hoc/common-components/BreakdownBadge'
import Filters from '../new-report/report-charging/child-components/Filters';
import "./css/HistoricDetails.css";

const HistoricDetails = ({
  // actions
  GetHistoricDetails,
  GetSubsRnNums,
  ExportHistoricDetails,

  // states
  subcribedRnNums,
  allHistoricDetails,
  dataCount,
  isLoading,
}) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isRnFilterWarnEnabled, setIsRnFilterWarnEnabled] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isDtFilterWarnEnabled, setIsDtFilterWarnEnabled] = useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPopup, setShowPopup] = useState(false);
  const [coordinate, setCoordinate] = useState();
  const ITEMS_PER_PAGE = 8;

  useEffect(() => {
    if (subcribedRnNums.length === 0) {
      GetSubsRnNums();
    }
  }, [GetSubsRnNums, subcribedRnNums]);

  useEffect(() => {
    if (dataCount > 0) {
      GetHistoricDetails({
        registrationNumbers: selectedOptions,
        fromDate: startDate,
        toDate: endDate,
        pageIndex: currentPage - 1,
        pageSize: ITEMS_PER_PAGE,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  function onDateChangeHandler({ startDate, endDate }) {
    allHistoricDetails.length = 0;
    setStartDate(startDate);
    setEndDate(endDate);
    setCurrentPage(1);
    if (selectedOptions && selectedOptions.length > 0) {
      GetHistoricDetails({
        registrationNumbers: selectedOptions,
        fromDate: startDate,
        toDate: endDate,
        pageIndex: 0,
        pageSize: ITEMS_PER_PAGE,
      });
    }
  }

  function onSelectionChange() {
    allHistoricDetails.length = 0;
  }

  const onSubmitHandler = () => {
    if (!selectedOptions?.length && !endDate && !startDate) {
      setIsRnFilterWarnEnabled(true);
      setIsDtFilterWarnEnabled(true);
      setTimeout(() => {
        setIsRnFilterWarnEnabled(false);
        setIsDtFilterWarnEnabled(false);
      }, 2000);
      return;
    } else if (!selectedOptions?.length) {
      setIsRnFilterWarnEnabled(true);
      setTimeout(() => {
        setIsRnFilterWarnEnabled(false);
      }, 2000);
      return;
    } else if (!(endDate && startDate)) {
      setIsDtFilterWarnEnabled(true);
      setTimeout(() => {
        setIsDtFilterWarnEnabled(false);
      }, 2000);
      return;
    }
    setCurrentPage(1);
    GetHistoricDetails({
      registrationNumbers: selectedOptions,
      fromDate: startDate,
      toDate: endDate,
      pageIndex: 0,
      pageSize: ITEMS_PER_PAGE,
    });
    setTimeout(() => {
      setIsSubmitClicked(true);
    }, 1000);
  };

  function exportToExcel() {
    ExportHistoricDetails({
      registrationNumbers: selectedOptions,
      fromDate: startDate,
      toDate: endDate,
    });
  }

  const handleMapCoOrdinateClick = (event) => {
    setShowPopup(true);
    setCoordinate(event);
  };

  const togglePopup = () => {
    setShowPopup((prevState) => !prevState);
  };


  return (
    <>
      <Container fluid>
        <div className="col-12 historic-details-filter-layout">
          <div className={`multi-select-width ${!selectedOptions[0] ? 'no-value-selected' : ''}`}>
            <MultiSelect
              isMultiSelect={true}
              setNoDataWarning={isRnFilterWarnEnabled}
              options={subcribedRnNums}
              selectedOptions={selectedOptions}
              setSelectedOptions={setSelectedOptions}
              onChange={onSelectionChange}
              placeholderColor='#C6C6C6'
              customBackgroundColor={{ backgroundColor: selectedOptions[0] ? "#FFFFFF" : "red" }}
            />
          </div>

          <div>
            <Button
              className="bttn height"
              id="getReport"
              type="submit"
              onClick={onSubmitHandler}
              disabled={
                !selectedOptions?.length ||
                !endDate ||
                !startDate
              }
            >
              Get Report
            </Button>
          </div>

          <div>
            <button
              disabled={
                !allHistoricDetails?.length ||
                !selectedOptions?.length ||
                !endDate ||
                !startDate
              }
              className={
                !allHistoricDetails?.length ||
                  !selectedOptions?.length ||
                  !endDate ||
                  !startDate
                  ? "dwn-btn dwn-btn-disabled"
                  : "dwn-btn"
              }
              onClick={() => {
                exportToExcel();
              }}
            >
              <BsDownload style={{ width: '22px', height: '22px' }} />
            </button>
          </div>

          <div className='col-4 date__picker'>
            <Filters onDateChangeHandler={onDateChangeHandler} maxRangeDays={5}></Filters>
          </div>
        </div>

        {allHistoricDetails?.length ? (
          <div className="bg-white mb-2 mt-4 position-relative trip__log__table historic-details-table-wrapper">
            <Table
              responsive={true}
              borderless
              className="mb-0"
              id="historic-details-table"
            >
              <thead>
                <tr className="th-border-bottom position-relative">
                  <th className="ps-2 text-nowrap"><p className="fw500">S.No</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Vehicle No.</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">OEM & Model</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">City</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">CAN<br />Date & Time</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Vehicle<br />Status</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">GPS</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">SoC<br />(%)</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Odometer<br />(kms)</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">DTE<br />(kms)</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Speed<br />(kmph)</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Batt.<br />Voltage (V)</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Batt.<br />Temp (°C)</p></th>
                  <th className="ps-2 text-nowrap"><p className="fw500">Sync<br />Date & Time</p></th>
                </tr>
              </thead>
              <tbody>
                {allHistoricDetails?.map((n, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1 + ((currentPage - 1) * ITEMS_PER_PAGE) + "."}</td>
                      <td>{n?.rn || '-'} <BreakdownBadge registrationNumber={n?.rn} /></td>
                      <td>{(n?.oem || '') + ' ' + (n?.mdl || '')}</td>
                      <td>{n?.city || '-'}</td>
                      <td>{n?.dts ? getFormattedDate(n.dts) : '-'}</td>
                      <td>{n?.vs === 'Idle' ? 'Live' : (n?.vs || '-')}</td>
                      <td>
                        {n?.lt && n?.lng ? (
                          <div className="d-flex flex-row gap-1 align-items-center justify-content-center">
                            <img
                              src="/images/svgicon/location.svg"
                              alt="location"
                              style={{ width: 18, cursor: "pointer" }}
                              onClick={() => handleMapCoOrdinateClick({
                                lat: parseFloat(n.lt),
                                lng: parseFloat(n.lng)
                              })}
                            />
                          </div>
                        ) : '-'}
                      </td>
                      <td>{n?.soc != null ? Math.round(n.soc) + '%' : '-'}</td>
                      <td>{n?.od != null ? Math.round(n.od) + ' kms' : '-'}</td>
                      <td>{n?.dte != null ? Math.round(n.dte) + ' kms' : '-'}</td>
                      <td>{n?.csp != null ? Math.round(n.csp) + ' kmph' : '-'}</td>
                      <td>{n?.vbv != null ? Math.round(n.vbv) + ' V' : '-'}</td>
                      <td>{n?.vbt != null ? n.vbt + ' °C' : '-'}</td>
                      <td>{n?.createdAt ? getFormattedDate(n.createdAt) : '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <Pagination
              disabled={false}
              totalPages={Math.ceil((dataCount || 0) / ITEMS_PER_PAGE)}
              currentPage={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        ) : (
          <></>
        )}
        {!allHistoricDetails?.length && isSubmitClicked && !isLoading ? (
          <NoRecordFound></NoRecordFound>
        ) : (
          <></>
        )}
      </Container>
      <Loader isLoading={isLoading} />
      {
        showPopup
        &&
        <div id="popup1" className={`popup ${showPopup ? "open" : ""}`}>
          <div className="popup-overlay" onClick={togglePopup}></div>
          <div className="popup-content">
            <MapAdddressByLocation isOpen={showPopup} toggleModal={togglePopup} CoOrdinates={coordinate} />
          </div>
        </div>
      }
    </>
  );
};

HistoricDetails.propTypes = {
  allHistoricDetails: PropTypes.array.isRequired,
  subcribedRnNums: PropTypes.array.isRequired,
  dataCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  GetHistoricDetails: PropTypes.func.isRequired,
  GetSubsRnNums: PropTypes.func.isRequired,
  ExportHistoricDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  allHistoricDetails: state.historicDetails.allHistoricDetails,
  subcribedRnNums: state.vehicle.subcribedRnNums,
  dataCount: state.historicDetails.dataCount,
  isLoading: state.loader.isLoading,
});

export default connect(mapStateToProps, {
  GetHistoricDetails,
  GetSubsRnNums,
  ExportHistoricDetails,
})(HistoricDetails);
